(() => {
  window.pbRenderPayPalCartMessages = () => {
    const paypalSdk = window.PayPalSDK || window.paypal;

    if (!paypalSdk || !paypalSdk.Messages) return false;

    document
      .querySelectorAll('.pb-paypal-message-under-checkout [data-pp-message]')
      .forEach((message, index) => {
        if (message.dataset.pbPaypalRendered === 'true' || message.querySelector('iframe')) {
          message.dataset.pbPaypalRendered = 'true';
          return;
        }

        const id = message.dataset.pbPaypalId || `cart-message-${Date.now()}-${index}`;
        message.dataset.pbPaypalId = id;
        message.dataset.pbPaypalRendered = 'true';

        try {
          paypalSdk.Messages().render(`[data-pb-paypal-id="${id}"]`);
        } catch (error) {
          message.dataset.pbPaypalRendered = 'false';
        }
      });

    return true;
  };

  if (window.pbPayPalCartMessageReady) return;
  window.pbPayPalCartMessageReady = true;

  let renderTimer;

  const scheduleRender = () => {
    window.clearTimeout(renderTimer);
    renderTimer = window.setTimeout(window.pbRenderPayPalCartMessages, 40);

    [0, 120, 350, 900, 1600, 2600].forEach((delay) => {
      window.setTimeout(window.pbRenderPayPalCartMessages, delay);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRender, { once: true });
  } else {
    scheduleRender();
  }

  window.addEventListener('load', scheduleRender);
  window.addEventListener('pageshow', scheduleRender);
  document.addEventListener('shopify:section:load', scheduleRender);
  document.addEventListener('cart:updated', scheduleRender);
  document.addEventListener('alpine:init', scheduleRender);

  new MutationObserver(scheduleRender).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
